export default "/assets/b86b92df18636147.svg"